import React from "react";

function SkipLink() {
  return (
    <a className="skip-link" href="#main-content">
      Kaloni te përmbajtja kryesore
    </a>
  );
}

export default SkipLink;
